import { Component, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject, defer, of, switchMap, timeout } from 'rxjs';
import { OTA_WARNING } from '../../enum/warning-ota';
import { ActivatedRoute } from '@angular/router';
import { PropertyManagementV3ControllerService } from '@booking/angular-booking-user-data-service';
import { TIME_OUT_REQUEST } from '@shared/constant';

@Injectable({
  providedIn: 'root'
})
export class PropertyManagementService {
  OTA_WARNING = OTA_WARNING;

  private _confirmSubject = new Subject<boolean>();
  private isUnderReview = new BehaviorSubject<boolean>(false);
  private propertyStatus = new BehaviorSubject<string>('');
  private resetDataContract = new BehaviorSubject<any>(null);
  private currentState = new BehaviorSubject<string>('');
  private propertySelected = new BehaviorSubject<string>('');

  constructor(
    private confirmationService: ConfirmationService, 
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private propertyManagementV3ControllerService: PropertyManagementV3ControllerService,
    
  ) { }

  setActivateRoute(data: boolean) {
    this._confirmSubject.next(data);
  }
  getActivateRoute() {
    return this._confirmSubject.asObservable();
  }

  setPropertyStatus(isUnderReview: boolean) {
    this.isUnderReview.next(isUnderReview);
  }

  getSignalResetDataContract() {
    return this.resetDataContract.asObservable();
  }

  setSignalResetDataContract(signal: any) {
    this.resetDataContract.next(signal);
  }

  getPropertyStatus() {
    return this.isUnderReview.asObservable();
  }

  setHotelStatus(propertyStatus: string) {
    this.propertyStatus.next(propertyStatus);
  }

  getPropertySelected() {
    return this.propertySelected.asObservable();
  }

  setPropertySelected(property: any) {
    this.propertySelected.next({ ...property }); // dùng spread để tránh side-effect nếu cần
  
    // Nếu có warning sẽ hết hạn => gọi API để lấy expired_date
    if (property.property_warnings.includes(OTA_WARNING.WILL_EXPIRED_ID)) {
  
      if (property.property_id) {
        this.propertyManagementV3ControllerService.getContractInfoByPropertyIdV3(property.property_id)
          .pipe(timeout(TIME_OUT_REQUEST))
          .subscribe({
            next: (response: any) => {
              if (response?.success && response?.data) {
                const expiryDate = response.data.approved_info?.expiry_date;
                // Gán lại expired_date và emit lại lần nữa
                const updatedProperty = {
                  ...property,
                  expired_date: expiryDate,
                };
                this.propertySelected.next(updatedProperty);
              }
            },
            error: (err) => {
              console.error('Error fetching contract info:', err);
            }
          });
      }
    }
  }
  

  getHotelStatus() {
    return this.propertyStatus.asObservable();
  }

  canDeactivate(isEdited: boolean): boolean | Observable<boolean> { 
    if (isEdited) {
      this.confirmationService.confirm({
        header: this.translateService.instant('COMMON.DISCARD_CHANGES'),
        message: this.translateService.instant(
          'OTA_MANAGEMENT.PROPERTY_PHOTOS.DISCARD_MESSAGE'
        ),
        rejectLabel: this.translateService.instant('COMMON.DISCARD'),
        acceptLabel: this.translateService.instant('COMMON.KEEP'),
        rejectButtonStyleClass: 'btn-save-as-draft-reject',
        acceptButtonStyleClass: 'btn-save-as-draft-accept',
        dismissableMask: true,
        defaultFocus: 'none',
        key: 'property-manager-cancel-popup',
        reject: (event: number) => {
          //  Rejects have two types:
          // The button in the footer is 1.
          // The X icon in the header is 2.        
          if (event === 1) {
            this.setActivateRoute(true)
          }
        },
        accept: () => {
          this.setActivateRoute(false)
        },
      });
    } else {
      return true;
    }
    return this.getActivateRoute()
  }

  setCurrentState(currentState: string) {
    this.currentState.next(currentState);
  }

  getCurrentState() {
    return this.currentState.asObservable();
  }
}
